module.exports = __webpack_public_path__ + "63f2b76d4d14054b870d7503709d9765.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/lion.svg
// module id = 91
// module chunks = 0